import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import Skeleton from 'react-loading-skeleton'

const Platform = ({ settingInfo, loading }) => {
    /**
     * Used for render the UI on home page
     */
  return (
    <section className='PLatform_section'>
      <Container>
        <div className="platform_inner">

          <div className="platform-head text-center">
            {
              loading ? <Skeleton width={"80%"} height={26} /> : <h2>{settingInfo?.heading1}</h2>}
            {
              loading ? <Skeleton width={"80%"} height={26} /> : <p>{settingInfo?.heading2}</p>}
          </div>


          <div className="bottom_app_img position-relative">

            {
              loading ? <Skeleton width={"80%"} height={50} /> : <img src={settingInfo?.image} alt="" className='img-fluid' />
            }



            <div className="arrrow_blue">
              <img src="/images/platformblue.png" alt="" className='img-fluid' />
            </div>


            <div className="arrrow_yelllow">
              <img src="/images/platformyellow.png" alt="" className='img-fluid' />
            </div>

          </div>

        </div>
      </Container>
    </section>
  )
}

export default Platform